JQ(document).ready(function () {
    /**
     * selectors
     */
    var dogs = JQ(".dog");
    var dogNames = dogs.find(".thv_dog-name");
    var breedSelectFields = dogs.find(".thv-breed");
    var dogCountInput = JQ("#thv_dog-count");
    var dogTabs = JQ(".dogs-tab");
    var goToOfferButton = JQ("#b_thv_go2datavn");
    var showOfferButton = JQ('#a_thv_an');
    var gotoCheckoutButton = JQ('#a_thv_da');
    var hybridsBreedsTextareaFields = JQ(".thv-hybrid-breeds");
    var insuranceBox = JQ("#div_thv_vers");
    var esgCheckbox = JQ("#f_thv_esg");
    var esgDocument = JQ(".display-on-esg_thv");
    var dnlsCheckbox = JQ("#f_thv_dnls");
    var insuranceEndDateField = JQ("#f_thv_ende");
    // mobile calculator related stuff
    var currentStep = 0;
    var mobileStartButton = JQ("#start-thv-insurance");
    var nextStepButtons = JQ("[data-type='next-step-mobile-btn']");
    var previousStepButtons = JQ("[data-type='prev-step-mobile-btn']");
    var isMobile = window.location.href.indexOf("/p/thv") !== -1;
    var plzField = JQ("#f_vn_plz");
    var bundleRebateSelect = JQ("#thv-buendelrabatt");
    var bundleRebateTextArea = JQ("#f_thv_rbt_bundle_text");
    var deckungssumme = JQ("#thv-deckungssumme :input");
    var stateBar = JQ("#statebar");
    var stepperButton = stateBar.find('[data-href]');
    var pencils = JQ(".pencil");
    var sendMobileThvOfferBtn = JQ("#send-mobile-thv-offer-btn");

    /**
     * event listeners
     */
    // get offer after form changes
    insuranceBox.change(function () {
        if (!isMobile) {
            getThvOffer();

            if (validateAllDogs() && validateBundleRebate()) {
                toggleGoToOfferButton(true);
            } else {
                toggleGoToOfferButton(false);
            }
        }

        notifyHeight();
    });

    // add/remove esg from zip archive
    esgCheckbox.change(function () {
        if (esgCheckbox.is(":checked"))
        {
            esgDocument.show();
            notifyHeight();
            if (PRIV.bparts['thv'].includes('esg')) return;
            PRIV.bparts['thv'].push('esg');
        } else {
            esgDocument.hide();
            notifyHeight();
            if (!PRIV.bparts['thv'].includes('esg')) return;
            PRIV.bparts['thv'] = PRIV.bparts['thv'].filter(function (elem) {
                return elem != 'esg';
            });
        }
    });

    dnlsCheckbox.change(function () {
        if (dnlsCheckbox.is(':checked')) {
            insuranceEndDateField.val(in3yearPlus1);
        } else {
            insuranceEndDateField.val(tomorrowInOneYear);
        }
    });

    // remove all the old shit event listners from the buttons
    mobileStartButton.off();

    nextStepButtons.each(function (index, element) {
        JQ(element).off();
        JQ(element).unbind();
        var button = JQ(element);

        button.click(function () {
            var step = parseInt(button.attr("data-step"));
            goToNextStep(step);
        });
    });

    previousStepButtons.each(function (index, element) {
        JQ(element).off();
        JQ(element).unbind();
        var button = JQ(element);

        button.click(function () {
            var step = parseInt(button.attr("data-step"));
            goToPrevStep(step);
        });
    });

    // get offer after start button is clicked on mobile
    mobileStartButton.click(function () {
        JQ("#div_0").addClass("hidden");
        JQ("#div_1").removeClass("hidden");

        // enable statebar for the first time
        currentStep = 1;
        handleStateBar();

        // get the first offer pirce with 1 dog
        getThvOffer();

        notifyHeight();
    });

    // get cities after plz change
    plzField.change(function (event) {
        JQ.getJSON(JSONURI,
            {
                bv_action: 'list',
                bv_type: 'orte',
                bv_subtype: event.currentTarget.value,
                sid: JQ('#f_sid').val()
            },
            ALL.setPLZ
        );
    });

    // validate after breed change
    breedSelectFields.change(function (element) {
        var dog = JQ(element.currentTarget).attr("data-dog");
        JQ("#thv-"+dog+"-hybrid-false").click();
        notifyHeight();
    });

    // validate after dog count change
    dogCountInput.change(function (e) {
        var textValue = e.currentTarget.value;
        var inputValue = parseInt(e.currentTarget.value);

        if (!textValue || isNaN(inputValue) || inputValue <= 0) {
            dogCountInput.val(1);
            inputValue = 1;
        }

        if (inputValue > 3) {
            dogCountInput.val(3);
            inputValue = 3;
        }

        dogTabs.each(function (index, element) {
            var dogNameInput = JQ("#thv_dog-"+index+"-name");
            var breedSelectInput = JQ("#thv_dog-"+index+"-breed");
            var breedsTextarea = JQ("#thv_dog-"+index+"-hybrid-breeds-text");

            if (index+1 <= inputValue) {
                JQ(element).css("display", "inline-block");
                dogNameInput.addClass("is-enabled");
                breedSelectInput.addClass("is-enabled");
                breedsTextarea.addClass("is-enabled");
            } else {
                JQ(element).css("display", "none");
                dogNameInput.removeClass("is-enabled");
                breedSelectInput.removeClass("is-enabled");
                breedsTextarea.removeClass("is-enabled");
            }
        });

        validateAllDogDataComplete();
        handleDogDisplay(inputValue-1);
        handleActiveTabChange(inputValue-1);
        getThvOffer();
        notifyHeight();
    });

    // add click events for tabs
    dogTabs.each(function (index, element) {
        if (!isMobile) {
            JQ(element).click(function () {
                handleActiveTabChange(index);
                handleDogDisplay(index);
                notifyHeight();
            })
        }
    });

    dogs.each(function (index) {
        // trigger backend call for an offer when the user choose a breed
        var breedSelectField = JQ(this).find(".thv-breed");
        var hybridTrueOption = JQ("#thv_dog-"+index+"-hybrid-true, #thv_dog-"+index+"-hybrid-true-label");
        var hybridFalseOption = JQ("#thv_dog-"+index+"-hybrid-false, #thv_dog-"+index+"-hybrid-false-label");
        var hybridsBreedsTextareaTab = JQ("#thv_dog-"+index+"-hybrid-breeds-tab");
        var hybridsBreedsTextareaField = JQ("#thv_dog-"+index+"-hybrid-breeds-text");

        hybridTrueOption.click(function () {
            hybridsBreedsTextareaTab.css("display", "table");
            breedSelectField.prop("selectedIndex", 0);
            hybridFalseOption.prop("checked", false);
        });

        hybridFalseOption.click(function () {
            hybridsBreedsTextareaTab.css("display", "none");
            hybridsBreedsTextareaField.val(null);
            hybridTrueOption.prop("checked", false);
        });

        notifyHeight();
    })

    // get a new offer if deckungssumme changes on first screen
    deckungssumme.each(function (index, element) {
        JQ(element).change(getThvOffer);
        notifyHeight();
    })

    // set the branch to thv in main js because idk it have to at this point ¯\_(ツ)_/¯
    // also set an / wd read variables to true (this is needed for validation at div_4 downloads thingi)
    JQ("[data-action-link='post-offer']").click(function () {
        ALL.branch = "thv";
        PRIV.an_read = true;
        validateInsuranceDetails();
        notifyHeight();
    })

    JQ("[data-action-link='get-pdf']").click(function () {
        PRIV.wd_read = true;
        validateInsuranceDetails();
        notifyHeight();
    });

    // mobile validation events
    // step 2 (dogs and insurance stuff)
    JQ("[data-mobile-div='2'] :input").each(function (index, element) {
        JQ(element).change(validateStepTwo);
        notifyHeight();
    });

    // step 3 user data
    JQ("[data-mobile-div='3'] :input").each(function (index, element) {
        JQ(element).change(function () {
            validateStepThree(element);
            notifyHeight();
        });
    });

    // step 4 insurance stuff
    JQ("[data-mobile-div='4'] :input").each(function (index, element) {
        JQ(element).change(function () {
            validateStepFour();
            notifyHeight();
        });
    });

    // change statebar after the user clicks on an edit icon in the last section
    pencils.each(function (index, element) {
        var pencil = JQ(element);
        var linkTo = pencil.attr("data-href");
        var linkItem = JQ(linkTo);
        var targetStep = linkItem.parents(".box").attr("data-mobile-div");

        pencil.click(function () {
            if (!targetStep) return;

            currentStep = parseInt(targetStep);

            handleStateBar();
            notifyHeight();
        });
    });

    // rebate selection
    bundleRebateSelect.change(function (e) {
        if (e.currentTarget.value !== "0") {
            JQ("#bundle-rbt-text-container-thv").css("display", "block");
        } else {
            JQ("#bundle-rbt-text-container-thv").css("display", "none");
        }
        notifyHeight();
    });

    // send the whole query to the be from mobile calculator
    sendMobileThvOfferBtn.click(function () {
        if (sendMobileThvOfferBtn.attr("disabled")) return;

        // disable button to prevent multiple requests from being fired
        sendMobileThvOfferBtn.attr("disabled", true);
        sendMobileThvOfferBtn.css("pointer-events: none");
        sendMobileThvOfferBtn.removeClass("button_enabled");
        notifyHeight();

        var query = JQ("#frm_thv").serialize();

        JQ.post('/tr/da', query, function (data) {
            if (!data.error) {
                stateBar.css("display", "none");

                for (var i = 0; i <= 5; i++) {
                    JQ("#div_" + i).css("display", "none");

                }
                JQ("#div_thv_rslt_inner").css("display", "none");

                JQ("#div_6").css("display", "block");
                ALL.triggerDataLayerEvent('Hundehalter', 'thv');
                notifyHeight();
            } else {
                // request failed => enable button
                sendMobileThvOfferBtn.attr("disabled", false);
                sendMobileThvOfferBtn.css("pointer-events: all");
                sendMobileThvOfferBtn.addClass("button_enabled");
                notifyHeight();
            }
        });
    });

    stepperButton.each(function (index, element) {
        JQ('#'+element.id).click(function (e) {
            var dataHref = JQ(e.currentTarget).attr('data-href');
            var step = parseInt(dataHref.split('_')[1]);

            // Jump forward is not allowed
            if (step >= currentStep) return;

            // Go back one step at a time until we reach the selected step
            // Do not go lower than step 1!
            while (step < currentStep && currentStep > 1) {
                goToPrevStep(currentStep - 1);
            }
            notifyHeight();
        });
    });

    /**
     * handlers
     */
    // handle dog display
    function handleDogDisplay(tabIndex) {
        if (isMobile) {
            var dogCount = tabIndex+1;

            JQ("[data-dog='"+dogCount+"']").css("display", "none");
            JQ("[data-dog-number='"+dogCount+"']").css("display", "none");

            for (var i = 0; dogCount > i; i++) {
                JQ("[data-dog='"+i+"']").css("display", "block");
                JQ("[data-dog-number='"+i+"']").css("display", "block");
            }

            notifyHeight();
            return;
        }

        dogs.each(function (index, element) {
            if (index === tabIndex) {
                JQ(element).css("display", "block");
            } else {
                JQ(element).css("display", "none");
            }
            notifyHeight();
        });
    }

    // active tab handler
    function handleActiveTabChange(index) {
        dogTabs.each(function (i, element) {
            parseInt(JQ(element).attr("data-tab")) === index ? JQ(element).addClass("active") : JQ(element).removeClass("active");
            notifyHeight();
        });
    }

    // handle mobile next step management
    function goToNextStep(step) {
        JQ("#div_"+(step-1)+"").addClass("hidden");
        JQ("#div_"+(step)+"").removeClass("hidden");

        currentStep = step;
        handleStateBar();

        if (currentStep === 2) validateStepTwo();
        if (currentStep === 3) validateStepThree();
        if (currentStep === 4) validateStepFour();
        if (currentStep === 5) fillOverviewItems();
        notifyHeight();
    }

    // handle mobile prev step management
    function goToPrevStep(step) {
        JQ("#div_"+(step+1)+"").addClass("hidden");
        JQ("#div_"+(step)+"").removeClass("hidden");

        currentStep = step;
        handleStateBar();

        if (currentStep === 1) toggleGoToOfferButton(true);
        if (currentStep === 2) validateStepTwo();
        if (currentStep === 3) validateStepThree();
        if (currentStep === 4) validateStepFour();
        notifyHeight();
    }

    // build a nice object from all dogs and their data
    function getThvDogsInputData() {
        var numberOfDogs = parseInt(JQ("#thv_dog-count").val());
        var serializedInsuranceFields;
        var data = {};

        // check for the strange mobile version because different template
        if (!isMobile) {
            serializedInsuranceFields = JQ("#div_thv_rslt :input").serializeArray();
        } else {
            serializedInsuranceFields = JQ("#thv-insurance-parameters :input").serializeArray();
        }

        // insurance specific fields
        serializedInsuranceFields.forEach(function (field) {
            data[field.name] = field.value;
        });

        data["thv_deckungssumme"] = JQ("#thv-deckungssumme input:checked").val() || null;
        data["thv_existenzschutz"] = JQ("#thv_existenzschutz option:selected").val() || null;
        data["thv_marktgarantie"] = JQ("#thv_marktgarantie input:checked").val() || null;

        // dog specific fields
        for (var i = 0; i < numberOfDogs; i++) {
            var dog = JQ("[data-dog='"+i+"']");
            var dogName = dog.find("[name='thv_dog-"+i+"-name']");
            var breed = dog.find("[name='thv_dog-"+i+"-breed']");
            var hybridInput = dog.find("#thv_dog-"+i+"-hybrid-true");
            var hybridBreeds = dog.find("[name='thv_dog-"+i+"-hybrid-breeds']");

            data["dog-"+i] = {
                name: dogName.val(),
                breed: breed.val(),
                isHybrid: hybridInput.prop("checked"),
                hybridBreeds: hybridBreeds.val(),
            };
        }

        return data;
    }

    // makes the api call and tries to get an offer for thv
    function getThvOffer() {
        if (THV && THV.blockRequest) return;
        JQ.getJSON(
            JSONURI,
            {
                action: "getpremium",
                branch: "thv",
                sid: JQ('#f_sid').val(),
                ...getThvDogsInputData() // Cannot be nested ("data" key) or it wont integrate properly with the rest of the application
            },
            function (data) {
                if (!data.error) {
                    // set header value to netto 2 ? (maklerrechner box)
                    JQ("#thv-netto-bonus-header").text(data.net2.str);

                    // set the offer values from BE to the text fields
                    PRIV.setPremium(data);
                }
                notifyHeight();
            }
        );
    }

    function fillOverviewItems() {
        ALL.setChkFlds("thv");

        // fill dog name fields at the end of the wizard
        dogNames.each(function (index, element) {
            var dogName = JQ(element).val();
            var dogOverViewName = JQ("#overview-dog-"+index+"-name");

            if (dogName.length === 0) {
                return;
            }

            dogOverViewName.text(dogName);
        });

        // fill dog breed fields at the end of the wizard
        breedSelectFields.each(function (index, element) {
            var breed = JQ(element);
            var isHybridBreed = JQ('#thv_dog-'+index+'-hybrid-true').is(':checked');
            var hybridBreeds = JQ("[name='thv_dog-"+index+"-hybrid-breeds']").val();
            var dogOverViewBreed = JQ("#overview-dog-"+index+"-breed");

            if (breed.attr("disabled")) {
                return;
            }

            if (isHybridBreed) {
                dogOverViewBreed.text('Mischling ('+ hybridBreeds +')');
            } else {
                dogOverViewBreed.text(breed.val());
            }
        });

        // fill relevant stuff that is not covered trough "ALL.setChkFlds"
        JQ("#overview-thv-deckungssumme").text(JQ("#thv-deckungssumme input:checked").val()+" Millionen €");
        JQ("#overview-thv_marktgarantie").text(JQ("#thv_marktgarantie input:checked").text());
        JQ("#overview-thv_existenzschutz").text(JQ("#thv_existenzschutz option:selected").text());
        JQ("#overview-thv-bundle-rebate").text(JQ("#thv-buendelrabatt option:selected").text());

        JQ("#overview-thv_marktgarantie").text(
            JQ("#thv_marktgarantie-1").attr("checked") ? "Ja" : "Nein"
        );

        JQ("#overview-thv-esg").text(
            esgCheckbox.is(":checked") ? "Ja" : "Nein"
        );
        notifyHeight();
    }

    function handleStateBar() {
        // start statebar progress
        if (currentStep === 1) {
            stateBar.removeClass("hidden").addClass("statebar4");
        }

        var prevStateDiv = JQ("#div_step_"+(currentStep-1));
        var prevStateText = JQ("#div_step_"+(currentStep-1)+" .statebar-text");
        var prevStateImg = JQ("#div_step_"+(currentStep-1)+" img");

        var currentStateDiv = JQ("#div_step_"+currentStep);
        var currentStateText = JQ("#div_step_"+currentStep+" .statebar-text");
        var currentStateImg = JQ("#div_step_"+currentStep+" img");

        var nextStateDiv = JQ("#div_step_"+(currentStep+1));
        var nextStateText = JQ("#div_step_"+(currentStep+1)+" .statebar-text");
        var nextStateImg = JQ("#div_step_"+(currentStep+1)+" img");

        var lastStateDiv = JQ("#div_step_"+(currentStep+2));
        var lastStateText = JQ("#div_step_"+(currentStep+2)+" .statebar-text");
        var lastStateImg = JQ("#div_step_"+(currentStep+2)+" img");

        // styling stuff
        prevStateDiv.removeClass("stepnum0 stepnum1").addClass("stepnum2");
        prevStateImg.css("display", "block");
        prevStateText.css("display", "none");

        currentStateText.css("display", "block");
        currentStateImg.css("display", "none");
        currentStateDiv.removeClass("stepnum0 stepnum2").addClass("stepnum1");

        nextStateDiv.removeClass("stepnum1 stepnum2").addClass("stepnum0");
        nextStateImg.css("display", "none");
        nextStateText.css("display", "none");

        lastStateDiv.removeClass("stepnum1 stepnum2").addClass("stepnum0");
        lastStateImg.css("display", "none");
        lastStateText.css("display", "none");
        notifyHeight();
    };


    /**
     * validators
     */
    // validates all dogs if their required fields are not empty
    function validateAllDogs() {
        var allDogsHaveNames = true;
        var allDogsHaveBreeds = true;
        var allDogsAreInsurable = true;
        var hybridsBreedsTextareaFieldsAreValid = true;

        dogNames.each(function (index, element) {
            var input = JQ(element);
            var isEnabled = input.hasClass("is-enabled");

            if (!isEnabled) return;

            if (input.val().length === 0) {
                allDogsHaveNames = false;
            }
        });

        breedSelectFields.each(function (index, element) {
            var input = JQ(element);
            var radioInput = JQ("#thv_dog-"+index+"-hybrid-false");
            var isEnabled = input.hasClass("is-enabled");

            if (!isEnabled) return

            if (input.val() === null && radioInput.prop("checked")) {
                allDogsHaveBreeds = false;
            }

            // Only check if the nth dogs breed is insurable if n+1 dogs are to be insured
            if (JQ(".dogs-container > [data-dog=" + index + "]").hasClass('is-enabled'))
            {
                // if the dog is not insurable and is not a hybrid dog
                if(!input.hasClass('is-insurable') && radioInput.prop('checked')) {
                    BC.debug("\"Hund " + (index+1) + "\" is not insurable")
                    allDogsAreInsurable = false;
                }
            }
        });

        hybridsBreedsTextareaFields.each(function (index, element) {
            var input = JQ(element);
            var radioInput = JQ("#thv_dog-"+index+"-hybrid-true");
            var breedSelectField = JQ("#thv_dog-"+index+"-breed");
            var isEnabled = input.hasClass("is-enabled");

            if (!isEnabled) return;

            if (input.val().length === 0 && radioInput.prop("checked")) {
                hybridsBreedsTextareaFieldsAreValid = false;
            }
        });

        validateAllDogDataComplete();

        return allDogsHaveNames && allDogsHaveBreeds && hybridsBreedsTextareaFieldsAreValid && allDogsAreInsurable;
    }

    function validateAllDogDataComplete() {
        var invalid = new Set();
        dogNames.each(function(index, element) {
            if (!JQ(element).val()) {
                invalid.add(index);
            }
        });

        breedSelectFields.each(function (index, element) {
            var radioInput = JQ("#thv_dog-"+index+"-hybrid-false");
            if (radioInput.prop("checked") && (!JQ(element).val() || !JQ(element).hasClass('is-insurable'))) {
                invalid.add(index);
            }
        });

        hybridsBreedsTextareaFields.each(function (index, element) {
            var radioInput = JQ("#thv_dog-"+index+"-hybrid-true");
            if (radioInput.prop("checked") && !JQ(element).val()) {
                invalid.add(index);
            }
        });

        dogTabs.each(function (index, element) {
            console.debug("Checking Dog "+index)
            if (invalid.has(index)) {
                JQ(element).find(".dog-info-waring-icon").show();
            } else {
                JQ(element).find(".dog-info-waring-icon").hide();
            }
        });
    }

    // validate user data
    function validateUserData(field) {
        var isValid = false;
        var input = JQ(field);

        if (field && input.val().length === 0) {
            ALL.chkDivReady("#div_3");
        }

        if (ALL.isVNcompleted()) {
            ALL.chkDivReady("#div_3");
            isValid = ALL.haveVN();
        }

        notifyHeight();
        return isValid;
    }

    // validate insurance details
    function validateInsuranceDetails() {
        notifyHeight();
        return PRIV.chkDA0();
    }

    function validateBundleRebate() {
        var selectValue = bundleRebateSelect.val();
        var textareaValue = bundleRebateTextArea.val();
        var valid = true;

        if (selectValue === "0") {
            valid = true;
        }

        if (selectValue !== "0" && textareaValue.length === 0) {
            valid = false;
        }

        return valid;
    }

    // validate mobile stuff
    function validateStepTwo() {
        if (validateAllDogs() && validateBundleRebate()) {
            getThvOffer();
            toggleGoToOfferButton(true);
        } else {
            toggleGoToOfferButton(false);
        }
    }

    function validateStepThree(field) {
        if (validateUserData(field)) {
            getThvOffer();
            toggleGoToOfferButton(true);
        } else {
            toggleGoToOfferButton(false);
        }
    }

    function validateStepFour() {
        if (validateInsuranceDetails()) {
            getThvOffer();
            toggleGoToOfferButton(true);
        } else {
            toggleGoToOfferButton(false);
        }
    }

    /**
     * other
     */
    function toggleGoToOfferButton(isEnabled) {
        if (isEnabled) {
            ALL.chkContactData();
            goToOfferButton.removeClass("ui-button-disabled ui-state-disabled");
            showOfferButton.removeClass("ui-button-disabled ui-state-disabled");
            gotoCheckoutButton.removeClass("ui-button-disabled ui-state-disabled");

            nextStepButtons.each(function (index, element) {
                JQ(element).css("pointer-events", "all");
                JQ(element).addClass("button_enabled");
            });
        } else {
            goToOfferButton.addClass("ui-button-disabled ui-state-disabled");
            showOfferButton.addClass("ui-button-disabled ui-state-disabled");
            gotoCheckoutButton.addClass("ui-button-disabled ui-state-disabled");

            nextStepButtons.each(function (index, element) {
                JQ(element).css("pointer-events", "none");
                JQ(element).removeClass("button_enabled");
            });
        }

        notifyHeight();
    }

    function notifyHeight() {
        const message = { height: document.body.scrollHeight , width: document.body.scrollWidth + 25};
        window.top.postMessage(message, "*");
    }
});

global.THV = {
    // Flag to stop getTHVOffer() from calling the API
    // This is used to prevent calculation overhead while filling the form after loadOffer was called
    blockRequest: false,
    init: function () {
        PRIV.hideLogoutAndAdministration();
        JQ(".thv-breed").autocomplete({
            position: {my: "right top", at: "right bottom"},
            source: '/TR/json?action=dogbreeds&sid=' + SESSION.getId(),
            minLength: 3,
            autoFocus: true,
            classes: {
                'ui-autocomplete': 'breed-picker',
            },
            select: function( e, ui ) {
                BC.debug('THV.init() JQ.autocomplete.select:', ui.item, 128);
                if (!ui.item.accepted) {
                    JQ(this).removeClass('is-insurable');
                    ALL.showHint('Die ausgewählte Hunderasse (' + ui.item.name + ') ist über die Waldenburger Versicherung AG nicht versicherbar.');
                } else {
                    JQ(this).addClass('is-insurable');
                }
            }
        });

        if (JQ('#f_thv_esg').is(':disabled')) {
            PRIV.bparts['thv'] = ['esg'];
        } else {
            PRIV.bparts['thv'] = [];
        }
        ALL.notifyHeight();
    },
};
